/**
 * 增强模式(步骤)
 */

import React, { useEffect, useMemo, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/helper';
import { SVGPureIcon } from '@/ui';
import DsEnhanceStore from './store';
import appLogger from '@public/log/monitor';
import './index.scss';
import { getFormattedResult } from '@shared/store/chat';
import Conf from '@/common/conf';
import Markdown from '@/components/markdown';
import ReferenceList from '../RefererList';
import globalStore from '@/store/global';
import Anchor from '@/components/chat-history/Anchor';

const EnhanceDs = observer(props => {
  const {
    folded = false,
    messageItem,
  } = props;
  const { 
    reasoning_text, 
    reasoning_duration, 
    refer_search, 
    result 
  } = messageItem;

  let isCompleted = !!reasoning_duration || result;
  let typing = !isCompleted;
  let is_so = globalStore.robotOnlineSo(messageItem?.role_id)
  const store = useLocalObservable(() => new DsEnhanceStore());
  useEffect(() => {
    store.updateData({ isFolded: folded });
  }, [folded]);

  const [open, setOpen] = useState(false);

  return (
    <div className={`ds-content pb-12px flex flex-col`}>
      {/* 网页搜索 */}
      {refer_search?.length ? (
        <div
          className={``}
        >
          {refer_search?.length ? (
            <div
              className="inline-flex items-center cursor-pointer h-32px rounded-[10px] pl-[10px] pr-[16px] py-[7px] mb-8px bg-[rgba(0,0,0,0.03)] hover:bg-gray-nav-hover"
              onClick={() => {
                setOpen(!open);
              }}
            >
              <SVGPureIcon
                className="w-[18px] h-[18px]"
                name="ds_search"
              ></SVGPureIcon>
              <div className="ml-6px mr-8px text-13px leading-18px">{`已搜索到${refer_search.length}个网页`}</div>
              <SVGPureIcon
                className="w-[12px] h-[7px] opacity-70 text-primary-opacity"
                name="enh-fold"
              ></SVGPureIcon>
            </div>
          ) : (
            <div className="inline-flex gap-6px items-center rounded-[10px] pl-[10px] pr-[16px] py-[7px] mb-8px bg-[rgba(0,0,0,0.03)] hover:bg-gray-nav-hover">
              <SVGPureIcon
                className="w-[18px] h-[18px] animate-spin text-black"
                name="loading"
              ></SVGPureIcon>
              搜索中...
            </div>
          )}
        </div>
      ) : null}
      {open ? (
        <ReferenceList className="mb-16px" refer_search={refer_search} />
      ) : null}
      {/* 深度思考 */}
      <div
        className={`${store.isFolded ? '' : 'mb-16px'}`}
      >
        <div
          className={`inline-flex items-center cursor-pointer rounded-[10px] pl-[10px] pr-[16px] py-[7px]  relative hover:bg-gray-nav-hover ${globalStore.isDark ? 'bg-[#31313A]' : 'bg-[rgba(0,0,0,0.03)]'}`}
          onClick={() => {
            store.toggleFolded();
          }}
        >
          <div className="h-18px text-[13px] leading-18px text-primary flex items-center relative">
            {/* {messageItem?.role_id == Conf.roleIds.assistant && asstInfo ? ( */}
            {isCompleted ? (
              <>
                <SVGPureIcon
                  className="w-[18px] h-[18px]"
                  name="ds_deep"
                ></SVGPureIcon>
                <div className='ml-6px mr-8px'>{`已深度思考（用时${reasoning_duration || 0}秒）`}</div>
                {/* <SVGPureIcon
            className="w-[12px] h-[7px] opacity-70 text-primary-opacity"
            name="enh-fold"
          ></SVGPureIcon> */}
                {/* 展开折叠按钮 */}
                <div
                  className={`size-16px flex items-center justify-center cursor-pointer transition-transform transition-[0.25s] transform ${!store.isFolded ? '' : 'rotate-[180deg]'}`}
                  onClick={event => {
                    event.stopPropagation();
                    store.toggleFolded();
                  }}
                >
                  <SVGPureIcon
                    className="w-[12px] h-[7px] opacity-70 text-primary-opacity"
                    name="enh-fold"
                  ></SVGPureIcon>
                </div>
              </>
            ) : (
              <>
                <div
                  className={`flex gap-6px items-center`}
                >
                  <SVGPureIcon
                    className="w-[18px] h-[18px] animate-spin text-black"
                    name="loading"
                  ></SVGPureIcon>
                  {is_so && !refer_search?.length ? '搜索中...':'思考中...'}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* 深度思考展开内容 */}
      <div
        className={`w-full flex text-left text-primary-opacity text-opacity-50 text-[14px] leading-[22px] ${store.isFolded ? 'hidden' : ''}`}
      >
        <div className="w-full pl-18px border-left-2px border-[#E5E5E5] whitespace-pre-wrap" style={{borderLeftWidth:'2px'}}>
          <Markdown 
            text={getFormattedResult((reasoning_text || "") + (!typing ? "\n" : ""), messageItem)} typing={typing} 
            components={{
              a: props => (
                <Anchor
                  {...props}
                  tooltipable={isCompleted}
                  references={messageItem}
                />
              ),
            }}
            />
        </div>
      </div>
    </div>
  );
});
export default EnhanceDs;
